// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Container":"Container-4qxz2p1e4eztnzzmk8eg8k2xgmenvnkzqga4saghfwa2dwxc2cyp8mty6mqm1au1hwzhbzgwnwv4erwvddcd9m97nrtjp66626xc8eh","MarginBottom":"MarginBottom-m13g579vt9tzyh3m35ju7cpv6ryayvn1gc14phsuq14g144ph77fm5fttf14hh6b4t3dneecngyxjvne1sx4msmd6r9x8v9ufntxsr","loading":"loading-yh8pnttgjv3z2xgn85kq99jh34657h6scf83eha57aj2x4r7q2h2p8fuwfbhrm7pbkdqnysah6wfymb4dqczb77cynhy83bg7v55nk","pulse":"pulse-ac2m6fxu6exw4kk81csp23c6jd6xb2tcfg8qkvzgmgnbrt3k7qg2jt4he8qwnjce8hzmp31m7czn3ht4agaptz9vz13169ftwhuf93"};


//////////////////
// WEBPACK FOOTER
// ./src/views/JobOffers/components/Article/JobOfferArticle/JobOfferArticle.module.scss
// module id = 1451
// module chunks = 0